import React, { useEffect, 
  // useState 
} from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { Alert, Spinner } from "reactstrap";
import { MdRefresh } from "react-icons/md";
import renderSelectField from "../../../../shared/components/form/Select";
import { getRafflesDropdown } from "../../actions/disbursement.actions";

const DrawDropDown = props => {
  const { allRaffles, label, dispatch, onChange, id, required } = props;
  // const [ raffleValue, setRaffleValue ] = useState("")

  const loadRaffle = () => {
    dispatch(getRafflesDropdown());
  };

  const handleInputChange = val => {
   
    // setRaffleValue(val);
  }

  useEffect(() => {
    dispatch(getRafflesDropdown());
  }, [dispatch]);


  return (
    <div className="form__form-group">
      <span className={`form__form-group-label ${required ? "required" : ""}`}>
        {label}
      </span>
      <div className="form__form-group-field">
        <Field
          id={id}
          name="raffleName"
          customChange={onChange}
          component={renderSelectField}
          placeholder="Select a value"
          options={allRaffles?.dropdown_response?.content || []}
          onInputChange={handleInputChange}
          valueKey="id"
          labelKey="name"
        />
      </div>
      {allRaffles && allRaffles.error ? (
        <Alert color="danger">
          Could not fetch draws
          {allRaffles.loading ? (
            <Spinner className="float-right" size="sm" color="danger" />
          ) : (
            <MdRefresh
              onClick={()=>{loadRaffle({ pageNum: 1, pageSize: 100, searchWord: "" })}}
              className="float-right pointer"
              size={20}
            />
          )}
        </Alert>
      ) : null}
    </div>
  );
};

export default connect(state => ({
  allRaffles: state.getDisbursement
}))(DrawDropDown);
